import { tradesApi } from "../store/api/tradesApi";
import { runMutation, runQuery } from "../store/api/runtime";
import type { LocationSnapshot } from "../types/location";

export interface TradeItem {
  id: string;
  userId: string;
  cardName: string;
  game: string;
  cardGame?: string;
  cardId?: string;
  cardNameCanonical?: string;
  condition?: string;
  estimatedValue?: number | null;
  zipCode?: string;
  location?: LocationSnapshot | null;
  countryCode?: string;
  locationLabel?: string;
  distanceMiles?: number;
  radius?: number;
  status?: string;
  matchCount?: number;
  createdAt?: string;
  boostExpiresAt?: string | null;
  lastBoostedAt?: string | null;
  ownerUsername?: string | null;
  ownerVerified?: boolean;
  ownerTrustScore?: string | number | null;
  [key: string]: unknown;
}

export interface PagedResult<T> {
  items: T[];
  total: number;
  limit: number;
  offset: number;
  hasMore: boolean;
}

export async function getTrades(
  params?: Record<string, string | number | boolean | undefined>,
): Promise<PagedResult<TradeItem>> {
  return runQuery(tradesApi.endpoints.getTrades.initiate, params);
}

export async function getMyPostedTrades(userId: string): Promise<TradeItem[]> {
  const response = await getTrades({ userId, status: "all", limit: 100, offset: 0 });
  return response.items || [];
}

export async function getTradeById(id: string): Promise<TradeItem> {
  return runQuery(tradesApi.endpoints.getTradeById.initiate, id);
}

export async function createTrade(formData: FormData): Promise<unknown> {
  return runMutation(tradesApi.endpoints.createTrade.initiate, formData);
}

export async function deleteTrade(id: string): Promise<unknown> {
  return runMutation(tradesApi.endpoints.deleteTrade.initiate, id);
}

export async function updateTradeLocation(id: string, location: LocationSnapshot): Promise<unknown> {
  return runMutation(tradesApi.endpoints.updateTradeLocation.initiate, { id, location });
}
